

export default {
  SET_USLUGE_ZA_ISPIT: (state, data) => {
    state.UslugeZaIspit = data;
  },

  REMOVE_PRIJAVLJENU_USLUGU: (state, kljuc) => {
    state.UslugeZaIspit = state.UslugeZaIspit.filter(x => x.DDLKljuc != kljuc);
  }
}



// WEBPACK FOOTER //
// ./VueSrc/Common/Store/Exams/Exam_mutations.js